<div
  class="add-task-container"
  [formGroup]="form"
>
  <mojo-editor
    [showCandidateMentionTags]="true"
    [showUserMentionForTasks]="true"
    [hasAnonymization]="hasAnonymization$ | async"
    [hasTalentPoolFeatureExtension]="talentPoolsService.hasTalentPoolPrivilegeAndFe() | async"
    formControlName="description"
    [placeholder]="'Task description'"
    [maxLength]="255"
    material="true"
    [footerPaddingXl]="true"
    toolbar=""
  >
    <div class="task-editor-footer">
      <div class="display-flex">
        <div
          class="due-date-wrapper"
          (click)="picker.open()"
        >
          <mat-icon
            [ngClass]="{'date-picked': form.controls.date.value !== null}"
            class="calendar-icon"
          >event</mat-icon>
          <span>{{getFormat(datePickerInput.value) || 'Due date'}}</span>
          <input
            #datePickerInput
            class="date-input"
            matInput
            [matDatepicker]="picker"
            [min]="today"
            formControlName="date"
          >
          <mat-datepicker #picker></mat-datepicker>
        </div>
        <div
          class="due-date-wrapper margin-left-10"
          #assignedMenuTrigger="matMenuTrigger"
          [matMenuTriggerFor]="menu"
          [matTooltip]="longName"
          [matTooltipDisabled]="disabledToolTip"
        >
          <mat-icon class="calendar-icon">person_add</mat-icon>
          <span>{{getName()}}</span>
        </div>
      </div>
      <div class="buttons display-flex">
        <button
          class="cancel-button"
          mat-button
          color="accent"
          (click)="cancelEdit()"
        >Cancel</button>
        <button
          mat-button
          class="m-rounded m-center send-button"
          (click)="confirmEdit()"
          [disabled]="form?.invalid"
        >
          <mat-icon
            color="primary"
            class="small-icon"
          >send</mat-icon>
        </button>
      </div>
    </div>
  </mojo-editor>

  <mat-menu #menu="matMenu">
    <mojo-candidate-input
      (click)="$event.stopPropagation()"
      [label]="'Search members'"
      [form]="form"
      (selectOption)="assignedMenuTrigger.closeMenu()"
      controlName="userInput"
    ></mojo-candidate-input>
  </mat-menu>
</div>
